import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {compareByEnum, compareById, FlowEventService} from '@app/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DocumentType, EventType, Location} from '@app/shared';
import {GlobalValuesService} from '../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-event-activator-section',
  standalone: false,

  templateUrl: './event-activator-section.component.html',
  styleUrl: './event-activator-section.component.less'
})
export class EventActivatorSectionComponent implements OnInit{

  @Input() event: EventType | undefined;
  @Input() eventsLenght!: number;
  @Input() eventForm: FormGroup | undefined;
  @Input() activatorForm: FormGroup | undefined;

  @Output() eventFormChange = new EventEmitter<FormGroup>();
  @Output() activatorFormChange = new EventEmitter<FormGroup>()
  protected readonly compareById = compareById;
  /** Compara por id numérico para tipo de documento (evita que string/number no coincidan al editar) */
  compareByDocId = (a: number, b: number) => a != null && b != null && Number(a) === Number(b);

  isUpdating: boolean = false;

  iconsList: string[] = [
    'home',
    'check_circle',
    'arrow_back',
    'arrow_forward',
    'done_all',
    'sync_alt',
    'keyboard_double_arrow_right',
    'keyboard_double_arrow_left',
    'swap_horiz',
    'swap_vert',
    'settings_backup_restore',
    'move_down',
    'move_up',
    'swipe_left_alt',
    'swipe_right_alt',
    'deployed_code',
    'rebase',
    'acute',
    'arrow_split',
    'captive_portal',
    'deployed_code_update',
    'cards',
    'recenter',
    'category_search',
    'modeling',
    'deployed_code_account',
    'deployed_code_history',
    'deployed_code_alert',
    'hourglass_arrow_down',
    'hourglass_arrow_up',
    'hourglass_disabled',
    'timer',
    'timer_arrow_down',
    'timer_arrow_up',
    'clock_arrow_down',
    'clock_arrow_up',
    'public',
    'public_off',
    'south_america',
    'globe',
    'globe_asia',
    'globe_uk',
    'globe_location_pin',
    'rocket_launch',
    'water_drop',
    'eco',
    'tactic',
    'orbit',
    'offline_bolt',
    'swap_calls',
    'conversion_path',
    'conversion_path_off',
    'timeline',
    'forklift',
    'trolley',
    'delivery_truck_bolt',
    'pallet',
    'box_add',
    'box_edit',
    'pin_drop',
    'location_on',
    'map',
    'home_pin',
    'explore',
    'flag',
    'person_pin_circle',
    'where_to_vote',
    'business_center',
    'factory',
    'home_work',
    'warehouse',
    'location_away',
    'local_gas_station',
    'package',
    'fmd_bad',
    'alt_route',
    'location_home',
    'signpost',
    'fire_truck',
    'cloud',
    'calendar_view_week',
    'slow_motion_video',
    'local_shipping',
    'flight',
    'flight_takeoff',
    'flight_land',
    'directions_bus',
    'train',
    'directions_boat',
    'boat_bus',
    'boat_railway',
    'water',
    'waves',
    'sports_score',
  ];

  colorList: string[] = [
    '#A8A8A8',
    '#0072F5',
    '#E5484D',
    '#FF990A',
    '#45A557',
    '#12A594',
    '#8E4EC6',
    '#EA3E83',
  ];

  activadorNameList = ['Subida documento', 'Validacion documento', 'Fecha Mojito', 'Manual'];

  estadosMojito = [
    'GateIn',
    'ATL',
    'ETD',
    'ATD',
    'ETA',
    'ATA',
    'ATDischarge',
    'GateOut',
    'EmptyReturnActual',
  ];

  locations: Location[] = [];
  documentTypes: DocumentType[] = [];

  constructor(private fb: FormBuilder, public gs: GlobalValuesService, public flowEventService: FlowEventService) {
    this.gs.places$.pipe(takeUntilDestroyed())
      .subscribe((value) => {
        this.locations = value
      })
    this.gs.documentTypes$.pipe(takeUntilDestroyed())
      .subscribe((value) => {
        this.documentTypes = value
      })
  }

  ngOnInit() {
    this.activatorForm = this.fb.group({
      name: [this.event?.activator?.name || this.activadorNameList[0], Validators.required],
      value: [this.event?.activator?.value, Validators.required],
      location: [this.event?.activator?.location || null],
      mojitoDynamicField: [this.event?.activator?.mojitoDynamicField || ''],
    });

    this.eventForm = this.fb.group({
      id: [this.event?.id || Date.now() * -1],
      name: [this.event?.name || '', Validators.required],
      sequence: [this.event?.sequence || this.eventsLenght + 1, Validators.required],
      icon: [this.event?.icon || '', Validators.required],
      color: [this.event?.color || '', Validators.required],
      activator: this.activatorForm,
    })

    this.activatorFormChange.emit(this.activatorForm);
    this.eventFormChange.emit(this.eventForm);
  }

  changeActivator(): void {
    if (this.isUpdating) return;
    this.isUpdating = true;

    this.activatorForm!.patchValue({
      value: null,
      location: null
    }, {emitEvent: false}); // Evita disparar valueChanges

    this.isUpdating = false;
  }

  updateEventForm(): void {
    if (this.isUpdating) return;
    this.isUpdating = true;

    // Usa setTimeout para romper el ciclo de detección
    setTimeout(() => {
      this.eventForm!.get('activator')?.patchValue(
        this.activatorForm!.value,
        {emitEvent: false}
      );
      this.isUpdating = false;
    });
  }

  protected readonly compareByEnum = compareByEnum;
}
